import { Reducer } from 'redux';

import { ExportAnswersResp } from '~src/modules/companySettings/types';
import { ThunkFailAction, ThunkSuccessAction } from '~src/services/apiMiddleware';
import {
  RESET_REPORT_FILTERS,
  SET_REPORT_FILTER,
  SET_REPORT_FILTERS,
  SET_REPORT_SORTING,
} from '~src/shared/sortSelector/constants/action.types';
import { setup } from '../../../config/server/server.config';

import * as types from './action.types';

interface CustomExport {
  loadingExportStatus: boolean;
  loadingInitExport: boolean;
  downloadUrl: string | null;
  exportStat: ExportAnswersResp;
}

export interface ExportState {
  customExport: CustomExport;
  exportStatus: ExportAnswersResp | null;
  downloadUrl: string | null;
  sorting: string;
  filters: Record<string, any>;
}

export function getInitialExportState(): ExportState {
  return {
    customExport: {
      loadingExportStatus: false,
      loadingInitExport: false,
      downloadUrl: null,
      exportStat: {} as any,
    },
    exportStatus: null,
    downloadUrl: null,
    sorting: '',
    filters: {},
  };
}

const exportReducer: Reducer<ExportState, ThunkSuccessAction | ThunkFailAction> = (
  state = getInitialExportState(),
  action,
) => {
  const { response } = action;
  switch (action.type) {
    case SET_REPORT_FILTER: {
      const filters = state.filters || {};
      if (action.filter.value === null || action.filter.value === undefined) {
        delete filters[action.filter.name];
      } else {
        filters[action.filter.name] = action.filter.value;
      }
      return { ...state, filters: { ...filters } };
    }
    case SET_REPORT_SORTING: {
      return { ...state, sorting: action.sorting };
    }
    case SET_REPORT_FILTERS: {
      return {
        ...state,
        filters: Object.entries(action.filters as Record<string, any>)
          .filter(([_, v]) => !!v)
          .reduce((carry, [k, v]) => ({ ...carry, [k]: v }), {}),
      };
    }
    case RESET_REPORT_FILTERS: {
      return { ...state, filters: {} };
    }
    case types.RequestExport.Request: {
      return state;
    }
    case types.RequestExport.Success: {
      return {
        ...state,
        downloadUrl: `${setup.LX_APP_URL}${action.response.data.url}`,
        exportStatus: action.response.data,
      };
    }
    case types.RequestExport.Failed: {
      return getInitialExportState();
    }
    case types.GET_COMPANY_INIT_EXPORT_REQUEST:
      return { ...state, customExport: { ...state.customExport, loadingInitExport: true } };

    case types.GET_COMPANY_INIT_EXPORT_SUCCESS:
      return {
        ...state,
        customExport: { ...state.customExport, ...response.data, loadingInitExport: false },
      };

    case types.GET_COMPANY_INIT_EXPORT_FAILED:
      return {
        ...state,
        customExport: { ...state.customExport, exportError: action.error.message, loadingInitExport: false },
      };

    case types.GET_COMPANY_EXPORT_STATUS_REQUEST:
      return { ...state, customExport: { ...state.customExport, loadingExportStatus: true } };

    case types.GET_COMPANY_EXPORT_STATUS_SUCCESS:
      return {
        ...state,
        customExport: {
          ...state.customExport,
          exportStat: response.data,
          loadingExportStatus: response.data.status === 'waiting' || response.data.status === 'processing',
          downloadUrl: `${setup.LX_APP_URL}${response.data.url}`,
        },
      };
    case types.GET_COMPANY_EXPORT_STATUS_FAILED:
      return {
        ...state,
        customExport: {
          ...state.customExport,
          exportError: action.error.message,
          loadingExportStatus: false,
        },
      };
    default:
      return state;
  }
};

export default exportReducer;
